export const en = {
    translation: {
        links: {
            forgotPassword: 'Forgot password',
            forgotPasswordURL:
                'https://valueblue.zendesk.com/hc/en-us/articles/115002753109-I-ve-forgotten-my-password-what-now-',
            needLoginHelp: 'Help with logging in',
            vbLogin: 'Login with ValueBlue',
            help: 'Help',
            cookiePrivacyStatement: 'Privacy and cookie statement',
            cookiePrivacyStatementURL:
                'https://cdn.bluedolphin.valueblue.nl/docs/PrivacyAndCookieStatement.pdf',
            vbAcademy: 'ValueBlue Academy',
            vbAcademyURL: 'https://valueblue.com/academy/',
            community: 'Community',
            communityURL: 'https://valueblue.zendesk.com/hc/en-us',
            webinars: 'Webinars',
            webinarsURL: 'https://valueblue.com/events/',
        },
        signIn: {
            title: 'Login to ',
            description: 'Please choose your identity provider',
        },
        errors: {
            title: 'Oops!',
            signUpDescription: 'This link is invalid.',
            noIdpDescription:
                'You must have at least one active identity provider to log in',
            genericDescription: 'Something went wrong.',
            text: 'Please ask your administrator for more detailed information.',
        },
        unSupportedBrowser: {
            warning:
                '<strong>This browser is not supported.</strong><br>For an optimal experience,<br>please use Microsoft Edge, Chrome, or Firefox',
        },
        loginErrors: {
            sessionExpired:
                'Session expired. Login required, BlueDolphin needs to update your authentication.',
            default:
                'Authentication failed. Please try to login again. If the error persists, please contact your system administrator.',
            userAccountNotExists:
                'Authentication failed. User account not found. Please contact your system administrator.',
        },
        tabTitle: 'Login - BlueDolphin',
        profileTitle: 'Profile - BlueDolphin',
        internetConnection: {
            lost: 'No network connection. Please connect to the internet to continue working',
            restored: 'We’re back! You may resume your work',
        },
        modalErrorActions: {
            refresh: 'Refresh',
        },
        profile: {
            firstName: 'First name',
            lastName: 'Last name',
            email: 'Email',
            personal: 'Personal Information',
            work: 'Work Information',
            preference: 'Preferences',
            functions: 'Your role',
            functionPlaceholder: 'Select your role',
            coworker: 'Your coworkers',
            coworkerPlaceholder: 'Select your answer(s)',
            responsibility: 'Your responsibilities',
            responsibilityPlaceholder: 'Select your responsibilities',
            department: 'Your department',
            departmentPlaceholder: 'Select your department',
            defaultViewMode: 'Default mode to open views',
            mode: {
                editMode: 'Edit Mode',
                viewMode: 'View Mode',
            },
            privacyText: 'Privacy and cookie statement',
            settings: 'User settings',
            nav: {
                profileTab: 'Profile',
            },
        },
        functions: {
            enterprise_architect: 'Enterprise Architect',
            business_architect: 'Business Architect',
            process_architect: 'Process Architect',
            security_architect: 'Security Architect',
            information_architect: 'Information Architect',
            application_architect: 'Application Architect',
            integration_architect: 'Integration Architect',
            infra_architect: 'Infra Architect',
            solution_architect: 'Solution (Project) Architect',
            process_engineer: 'Process Engineer',
            integration_specialist: 'Integration Specialist',
            infra_solution_designer: 'Infra Solution Designer',
            information_data_designer: 'Information / Data Designer',
            business_consultant: 'Business Consultant',
            application_portfolio_manager: 'Application Portfolio Manager',
            project_portfolio_manager: 'Project Portfolio Manager',
            functional_application_manager: 'Functional Application Manager',
            technical_application_manager: 'Technical Application Manager',
            technical_maintenance: 'Technical Maintenance',
            service_manager: 'Service Manager',
            cio_cfo: 'CIO / CFO',
            it_operations_manager: 'IT Operations Manager',
            business_continuity_manager: 'Business Continuity Manager',
            project_manager: 'Project Manager',
            vendor_manager: 'Vendor Manager',
            compliance_manager: 'Compliance Manager',
            business_manager: 'Business Manager',
            servicedesk_employee: 'Servicedesk Employee',
            business_employee: 'Business Employee',
            other: 'Other',
            privacy_officer: 'Privacy Officer',
            security_officer: 'Security Officer',
            information_manager: 'Information Manager',
            analyst: 'Analyst',
            bluedolphin_admin: 'BlueDolphin Admin',
        },
        responsibilities: {
            business_capability_modelling: 'Business capability modelling',
            bi_architecture: 'BI Architecture',
            application_portfolio_management:
                'Application Portfolio Management',
            infra_netwerk_design: 'Infra / Netwerk Design',
            business_architecture: 'Business Architecture',
            engineering: 'Engineering',
            organizational_design: 'Organizational Design',
            data_modelling: 'Data Modelling',
            application_architecture: 'Application Architecture',
            application_integration: 'Application Integration',
            implement_it_industry_standards: 'Implement IT industry standards',
            security: 'Security',
            services_design: 'Services Design',
            determine_architecture_principles:
                'Determine Architecture principles',
            roadmapping_strategy: 'Roadmapping – Strategy',
            roadmapping_projects: 'Roadmapping – Projects',
            project_architecture_designs: 'Project Architecture Designs',
            architecture_visualization: 'Architecture Visualization',
            building_block_design: 'Building Block Design',
            solutions_modelling: 'Solutions Modelling',
            business_analysis:
                'Business Analysis (using, e.g., statistical tools, detailed methods, or testing procedures)',
            project_portfolio_management: 'Project Portfolio Management',
            stakeholder_management: 'Stakeholder Management',
            risk_management: 'Risk Management',
            internal_communications: 'Internal Communications',
            create_requirements: 'Create requirements',
            progress_reporting: 'Progress Reporting',
            other: 'Other',
        },
        departments: {
            it_general: 'IT General',
            it_architecture: 'IT Architecture',
            it_infra: 'IT Infra',
            it_operations: '(IT) Operations',
            it_development: 'IT Development',
            human_resoure_management: 'Human Resoure Management',
            risk_control: 'Risk & Control',
            manufacturing: 'Manufacturing',
            finance: 'Finance',
            marketing: 'Marketing',
            communications: 'Communications',
            service_department: 'Service department',
            customer_support: 'Customer Support',
            procurement: 'Procurement',
            sales: 'Sales',
            operations: 'Operations',
            production: 'Production',
            engineering: 'Engineering',
            research_development: 'Research & Development',
            data_analysis: 'Data analysis',
            project_management: 'Project Management',
            information_management: 'Information Management',
            security: 'Security',
            general_management: 'General Management',
            other_business_department: 'Other Business Department',
            other_it_department: 'Other IT Department',
            other: 'Other',
        },
    },
};
